<template>
<div class="form-group">
  <label
    class="placeholder placeholder-static"
  >
    {{placeholder}}
  </label>

  <div class="radio-group ratings-group">
    <div 
      v-for="(classification, index) in classifications" 
      v-bind:key="classification.value"
      class="rating-group"
    >
      <input 
        type="radio"
        :value="classification.value" 
        name="rb-classification" 
        :id="'rb-classification-' + index"
        :checked="classification.value == defaultClassification"
        @change="onChange(classification.value)"
        v-model="selectedClassification"
      >
      <label 
        :for="'rb-classification-' + index" 
        :class="'radio rating-' + index"
      >
        {{classification.label}}
      </label>
    </div>
  </div>

  <div v-if="v$.selectedClassification.$error" class="error">Remediation classification is required</div>

  <input
    class="form-control"
    :name="name"
    :id="id"
    :value="selectedClassification"
    type="hidden"
  />
</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  props: {
    defaultClassification: String,
    id: String,
    name: String,
    value: String,
    type: {
      type: String,
      default: "radio"
    },
    placeholder: {
      type: String,
      default: "Classification"
    }
  },

  validations () {
    return {
      selectedClassification: {
        required
      }
    }
  },

  setup () {
    return {
      v$: useVuelidate()
    }
  },

  data() {
    return {
      selectedClassification: 3,
      classifications: [
        { label: '-', value: "0" },
        { label: 'A', value: "1" },
        { label: 'B', value: "2" },
        { label: 'C', value: "3" },
        { label: 'D', value: "4" },
        { label: 'F', value: "5" }
      ]
    }
  },

  computed: {
    isValid: function() {
      this.validate();

      return !this.v$.selectedClassification.$error;
    }
  },

  mounted: function() {
    this.selectedClassification = this.defaultClassification;
  },

  methods: {
    onChange: function(val) {
      this.$emit("change", this.selectedClassification);
    },

    validate: function() {
      this.v$.selectedClassification.$touch();
    }
  }
};
</script>
